var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoyaltyPerk3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 89 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#719C89",
  d: "m17.015 12.32-3.223-4.342L.086 31.91H24.07V0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  d: "m0 32 5.116-8.925h18.957V32z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#719C89",
  d: "m5.137 23.073 5.064-8.925h13.871v8.925zm43.95-10.752-3.222-4.343L32.159 31.91h23.984V0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  d: "m32.073 32 5.116-8.925h18.957V32zm5.136-8.927 5.065-8.925h13.87v8.925zm43.866-10.707-3.223-4.343-13.707 23.933H88.13V.045z"
})));
export default SvgLoyaltyPerk3;